import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setAuthToken, formatError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const processed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || window.location.hash;
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            setError("Token di sessione mancante.");
            setTimeout(() => navigate("/login", { replace: true }), 2000);
            return;
        }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                if (data.token) setAuthToken(data.token);
                await refresh();
                // clean URL
                window.history.replaceState({}, document.title, "/");
                navigate("/", { replace: true });
            } catch (e) {
                setError(formatError(e));
                setTimeout(() => navigate("/login", { replace: true }), 4000);
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen bg-deep flex items-center justify-center text-warm">
            <div className="text-center max-w-md px-6">
                {!error ? (
                    <>
                        <Loader2 className="w-10 h-10 text-brand animate-spin mx-auto mb-4" />
                        <div className="font-display text-xl font-bold mb-2">Accesso in corso...</div>
                        <div className="text-elegant text-sm">Valido la sessione Google con Smart Table.</div>
                    </>
                ) : (
                    <>
                        <div className="text-red-400 font-display text-xl font-bold mb-2">Accesso negato</div>
                        <div className="text-elegant text-sm">{error}</div>
                        <div className="text-elegant text-xs mt-3">Reindirizzamento al login...</div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AuthCallback;
